// Generated by CoffeeScript 1.12.4
(function() {
  var deepEqual, dereference, generateSchema;

  deepEqual = require('assert').deepEqual;

  dereference = require('./dereference');

  generateSchema = function(root, top) {
    var exclusive, i, item, items, j, k, key, len, len1, len2, len3, m, member, option, optionSchema, prop, properties, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, required, schema, typeAttr;
    if (top == null) {
      top = true;
    }
    schema = {};
    if (top) {
      schema['$schema'] = 'http://json-schema.org/draft-04/schema#';
    }
    switch (root.element) {
      case 'boolean':
      case 'string':
      case 'number':
        schema.type = root.element;
        if (((ref = root.attributes) != null ? ref["default"] : void 0) != null) {
          schema["default"] = root.attributes["default"];
        }
        break;
      case 'enum':
        schema["enum"] = [];
        ref1 = root.content || [];
        for (i = 0, len = ref1.length; i < len; i++) {
          item = ref1[i];
          schema["enum"].push(item.content);
        }
        break;
      case 'array':
        schema.type = 'array';
        items = [];
        ref2 = root.content || [];
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          item = ref2[j];
          items.push(generateSchema(item, false));
        }
        if (items.length === 1) {
          schema.items = items[0];
        } else if (items.length > 1) {
          try {
            schema.items = items.reduce(function(l, r) {
              return deepEqual(l, r) || r;
            });
          } catch (error) {
            schema.items = {
              'anyOf': items
            };
          }
        }
        break;
      case 'object':
      case 'option':
        schema.type = 'object';
        schema.properties = {};
        required = [];
        properties = root.content.slice(0);
        ref3 = root.content;
        for (k = 0, len2 = ref3.length; k < len2; k++) {
          member = ref3[k];
          if (member.element === 'select') {
            exclusive = [];
            ref4 = member.content;
            for (m = 0, len3 = ref4.length; m < len3; m++) {
              option = ref4[m];
              optionSchema = generateSchema(option, false);
              ref5 = optionSchema.properties;
              for (key in ref5) {
                prop = ref5[key];
                exclusive.push(key);
                schema.properties[key] = prop;
              }
            }
            if (!schema.allOf) {
              schema.allOf = [];
            }
            schema.allOf.push({
              not: {
                required: exclusive
              }
            });
            continue;
          }
          key = member.content.key.content;
          schema.properties[key] = member.content.value ? generateSchema(member.content.value, false) : {
            type: 'string'
          };
          if (((ref6 = member.meta) != null ? ref6.description : void 0) != null) {
            schema.properties[key].description = member.meta.description;
          }
          if ((ref7 = member.attributes) != null ? ref7.typeAttributes : void 0) {
            typeAttr = member.attributes.typeAttributes;
            if (typeAttr.indexOf('required') !== -1) {
              if (required.indexOf(key) === -1) {
                required.push(key);
              }
            }
            if (typeAttr.indexOf('nullable') !== -1) {
              schema.properties[key].type = [schema.properties[key].type, 'null'];
            }
          }
        }
        if (required.length) {
          schema.required = required;
        }
    }
    if (((ref8 = root.meta) != null ? ref8.description : void 0) != null) {
      schema.description = root.meta.description;
    }
    if ((ref9 = root.attributes) != null ? ref9.typeAttributes : void 0) {
      typeAttr = root.attributes.typeAttributes;
      if (typeAttr.indexOf('nullable') !== -1) {
        schema.type = [schema.type, 'null'];
      }
    }
    return schema;
  };

  module.exports = function(root, dataStructures) {
    return generateSchema(dereference(root, dataStructures));
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/schema.js
// module id = 219
// module chunks = 0